import { render } from "./designDatePreview.vue?vue&type=template&id=28c8c15c"
import script from "./designDatePreview.vue?vue&type=script&lang=js"
export * from "./designDatePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__